<template>
  <modal
    :header-text="$t('modal.addingNewProfile')"
    :button-text="$t('global.add')"
    :class="$style.modal"
    @action="addProfile()"
    @close="$emit('close')"
  >
    <div :class="$style.inputContainer">
      <label :class="$style.label">{{ $t('modal.profileName') }}</label>
      <input
        v-model="profileName"
        type="text"
        :class="$style.input"
      >
    </div>

    <div :class="$style.inputContainer">
      <label :class="$style.label">{{ $t('modal.createBasedOnProfile') }}</label>
      <select
        v-model="selectedProfile"
        :class="$style.input"
      >
        <option
          v-for="option in profiles"
          :key="option.id"
          :value="option.id"
        >
          {{ option.name }}
        </option>
      </select>
    </div>
  </modal>
</template>

<script>
  import { addProfile } from '@/api/methods/settings';
  import Modal from '@/components/common/modal/settings-modal.vue';

  export default {
    components: { Modal },
    props: ['profiles'],
    data: () => ({
      profileName: '',
      selectedProfile: 1,
    }),

    methods: {
      close() {
        this.$emit('close');
      },
      async addProfile() {
        const result = await addProfile(this.profileName, this.selectedProfile);
        if (result === 'success') this.profileName = '';
        this.$emit('update');
      },
    },
  };
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
    width: 60%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }
  .inputContainer {
    font-size: 13px;
    margin: 5px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }
  .label {
    width: 40%;
  }
</style>
